import axios from "axios";
import API_BASE_URL from "./apiConfig";

const API_URL = `${API_BASE_URL}/api`;

const subscriptionPlanService = {
  async getSubscriptionPlans() {
    try {
      const response = await axios.get(`${API_URL}/subscription-plans`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getSubscriptionPlanById(id) {
    try {
      const response = await axios.get(
        `${API_URL}/subscription-plans/${id}`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async createSubscriptionPlan(planData) {
    try {
      const response = await axios.post(
        `${API_URL}/subscription-plans`,
        planData,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async updateSubscriptionPlan(id, planData) {
    try {
      const response = await axios.put(
        `${API_URL}/subscription-plans/${id}`,
        planData,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async deleteSubscriptionPlan(id) {
    try {
      const response = await axios.delete(
        `${API_URL}/subscription-plans/${id}`,
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default subscriptionPlanService;
